<template>
  <div id="order">
    <a-tabs
      class="order-sub-menu"
      v-model="topMenuKey"
      @change="handleTabChange"
    >
      <template v-for="item in menus">
        <a-tab-pane :key="item.key" :tab="item.name" />
      </template>
    </a-tabs>
    <a-form :form="form">
      <a-row a-row class="row" justify="space-between" align="middle">
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">添加时间</a-col>
            <a-col span="18">
              <a-form-item>
                <a-range-picker
                  style="display:block"
                  format="YYYY-MM-DD"
                  v-decorator="[
                    'dateModel',

                    { rules: [{ required: false, message: '' }] }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">负责BD</a-col>
            <a-col span="18">
              <a-form-item>
                <a-select
                  v-decorator="[
                    'bdname',
                    {
                      /* initialValue: valuebd, */
                      rules: [{ required: false, message: '请填写BD' }]
                    }
                  ]"
                  showSearch
                  placeholder="请填写BD"
                  style="width: 100%"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearchBD"
                  :notFoundContent="null"
                >
                  <a-select-option
                    v-for="(item, index) in databd"
                    :key="index"
                    :value="item.uid"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row a-row class="row" justify="space-between" align="middle">
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="8">
              <a-select class="select" v-model="main">
                <a-select-option value="name">公司实名</a-select-option>
                <a-select-option value="short_name">公司简称</a-select-option>
                <a-select-option value="full_name">公司虚名</a-select-option>
              </a-select>
            </a-col>
            <a-col span="15" class="form-label noborder">
              <a-form-item>
                <a-input v-model="mainValue" placeholder="请输入公司名" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">所在城市</a-col>
            <a-col span="18">
              <a-form-item>
                <a-cascader
                  changeOnSelect
                  :options="options"
                  v-model="category_id"
                  :fieldNames="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="请选择城市"
                  style="display:block"
                  @click="getOptions"
                  @change="onChangecity"
                ></a-cascader>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">合同类型</a-col>
            <a-col span="18">
              <a-form-item>
                <a-select class="select" v-model="stype">
                  <a-select-option value="FLASH_INTERVIEW"
                    >闪面试</a-select-option
                  >
                  <a-select-option value="TRIAL_ORDER">试单</a-select-option>
                  <a-select-option value="ENTRY">入职</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <div class="order-page-type">
      <a-button size="large" class="screen" type="primary" @click="selectList"
        >筛选</a-button
      >
      <a-button size="large" class="clear-screen" @click="clearSelect"
        >清空筛选条件</a-button
      >
      <span>共找到 {{ total }} 条信息</span>
      <a-button
        v-if="isGranted('company_manager.company_list.btn_add_company')"
        size="large"
        class="screen left"
        type="primary"
        @click="operateStaff()"
        >新建客户</a-button
      >
    </div>
    <!-- <a-row type="flex" align="middle" justify="start" class="sort-bar">
      <template v-for="sort in sorts">
        <a-col span="3" class="sort" :key="sort.id" @click="changeSort(sort)">
          {{ sort.name }}
          <a-icon :type="`arrow-${sort.arr}`"></a-icon>
        </a-col>
      </template>
    </a-row>-->
    <a-spin :spinning="loading" size="large">
      <ul class="data-list">
        <template v-for="(item, index) in listData">
          <li class="list" :key="index" @click="showClientMsg(item.id)">
            <a-row
              class="row"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <a-col class="content">
                <div>
                  <span class="company"
                    >{{ item.name }}- {{ item.short_name }}</span
                  >
                  <span :class="[item.is_sign === '0' ? 'unsign' : 'sign']"
                    >（{{ item.is_sign === "0" ? "未签约" : "已签约" }}）</span
                  >
                  <a-button
                    size="small"
                    :class="[
                      item.audit_status === 'ACCEPTED' ? 'status' : 'unstatus'
                    ]"
                  >
                    {{
                      item.audit_status === "ACCEPTED"
                        ? "审核通过"
                        : item.audit_status === "CREATED"
                        ? "待审核"
                        : item.audit_status === "REJECTED"
                        ? "审核不通过"
                        : "待审核"
                    }}
                  </a-button>
                </div>
                <div class="companyStatus">{{ item.full_name }}</div>
                <div>
                  <span>{{ item.first_category_name }}</span>
                  <span>|</span>
                  <span>
                    {{ item.first_category_name }}/{{
                      item.second_category_name
                    }}
                  </span>
                  <span>|</span>
                  <span>{{ item.city_name }}</span>
                  <span>|</span>
                  <span>{{ item.financing_stage_name }}</span>
                  <span>|</span>
                  <span>{{ item.scale_name }}</span>
                </div>
              </a-col>
              <a-col class="contentLeft">
                <div class="createtime">创建时间: {{ item.created_at }}</div>
                <div class="createtime">创建人: {{ item.user_name }}</div>
                <div>
                  <span
                    @click.stop="
                      $router.push({
                        path: '/hr-manage',
                        query: { companyId: item.id, companyName: item.name }
                      })
                    "
                  >
                    关联HR：
                    <a class="blue">{{ item.hr_count }}</a>
                    人
                  </span>
                  <span
                    class="gap"
                    @click.stop="
                      $router.push({
                        path: '/post',
                        query: { companyName: item.name }
                      })
                    "
                  >
                    招聘职位：
                    <a class="blue">{{ item.job_count }}</a>
                    个
                  </span>
                </div>
              </a-col>
              <a-col class="contentRight">
                <div
                  class="edit"
                  v-if="isGranted('company_manager.company_list.btn_list_edit')"
                  :class="[item.audit_status !== 'CREATED' ? 'show' : 'hide']"
                >
                  <a href="javascript:void(0)" @click.stop="operateStaff(item)"
                    >编辑</a
                  >
                </div>
                <div
                  class="edit"
                  v-if="isGranted('company_manager.company_list.btn_list_sign')"
                  :class="[
                    item.audit_status === 'ACCEPTED' && item.is_sign === '0'
                      ? 'show'
                      : 'hide'
                  ]"
                >
                  <a href="javascript:void(0)" @click.stop="goContract(item)"
                    >签约</a
                  >
                </div>
                <div
                  class="edit"
                  v-if="isGranted('company_manager.company_list.btn_list_sign')"
                  :class="[
                    item.audit_status === 'ACCEPTED' && item.is_sign === '1'
                      ? 'show'
                      : 'hide'
                  ]"
                >
                  <a href="javascript:void(0)" @click.stop="goContract(item)"
                    >合同管理</a
                  >
                </div>
                <div
                  class="edit"
                  v-if="isGranted('company_manager.company_list.btn_list_add_hr')"
                  :class="[item.audit_status === 'ACCEPTED' || item.audit_status === 'CREATED' ? 'show' : 'hide']"
                >
                  <a href="javascript:void(0)" @click.stop="addHr(item)"
                    >添加HR</a
                  >
                </div>
                <div
                  class="edit"
                  v-if="
                    isGranted('company_manager.company_list.btn_list_audit')
                  "
                  :class="[
                    item.audit_status === 'ACCEPTED' ||
                    item.audit_status === 'REJECTED'
                      ? 'hide'
                      : 'show'
                  ]"
                >
                  <a href="javascript:void(0)" @click.stop="reviewPass(item)"
                    >审核通过</a
                  >
                </div>
                <div
                  v-if="
                    isGranted('company_manager.company_list.btn_list_audit')
                  "
                  class="edit"
                  :class="[
                    item.audit_status === 'ACCEPTED' ||
                    item.audit_status === 'REJECTED'
                      ? 'hide'
                      : 'show'
                  ]"
                >
                  <a href="javascript:void(0)" @click.stop="reviewUnPass(item)"
                    >审核不通过</a
                  >
                </div>
                <div
                  class="edit"
                  v-if="
                    isGranted('company_manager.company_list.btn_company_remark')
                  "
                >
                  <img
                    src="../../../../assets/bianji.png"
                    alt
                    class="editimg"
                    @click.stop="editLook(item)"
                  />
                  <a href="javascript:void(0)" @click.stop="showLook(item)"
                    >拜访记录</a
                  >
                </div>
                <div
                  v-if="user.uid === '1'"
                  class="edit show"
                >
                  <a href="javascript:void(0)" @click.stop="$refs.transformModal.show(item)"
                    >转移客户</a
                  >
                </div>
              </a-col>
            </a-row>
          </li>
        </template>
      </ul>
      <div style="margin-top: 50px;text-align: center" v-show="total == 0">
        暂无数据
      </div>
    </a-spin>
    <a-row
      type="flex"
      align="middle"
      justify="end"
      :style="{ padding: '30px 0' }"
    >
      <Pagination
        ref="pagination"
        :total="total"
        @change="getListData"
        v-show="total != 0"
      ></Pagination>
      <EditClient ref="editModal" :getListData="getListData"></EditClient>
      <ReviewPass ref="reviewPassModel" :callback="getListData"></ReviewPass>
      <ReviewUnPass
        ref="reviewUnPassModel"
        :callback="getListData"
      ></ReviewUnPass>
      <EditMessage ref="editHrModal" :getListData="getListData"></EditMessage>
      <ClientMessage
        ref="ClinetMsgModal"
        :companyInfo="companyInfo"
        :callback="operateStaff"
      ></ClientMessage>
      <EditLook ref="editLook" :callback="getListData"></EditLook>
      <ShowLook ref="showLook"></ShowLook>
      <transform-staff-modal ref="transformModal" :callback="getListData"></transform-staff-modal>
    </a-row>


  </div>
</template>

<script>
import Pagination from "./Pagination";
import EditClient from "./editClient";
import EditMessage from "./editMessage";
import ClientMessage from "./clientMessage";
import ReviewUnPass from "./reviewUnPass";
import ReviewPass from "./reviewPass";
import EditLook from "./editLook";
import ShowLook from "./showLook";
import { mapState } from "vuex";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import debounce from "lodash/debounce";
import TransformStaffModal from "./transform-modal.vue";

const menus = [
  {
    name: "全部客户",
    key: 0
  },
  {
    name: "已签约客户",
    key: 1
  },
  {
    name: "未签约客户",
    key: 2
  },
  {
    name: "待审核客户",
    key: 3
  },
  {
    name: "审核未通过",
    key: 4
  },
  {
    name: "审核通过",
    key: 5
  }
];
const sorts = [
  {
    name: "关联HR数",
    id: 0,
    value: "score_desc",
    arr: "down"
  },
  {
    name: "招聘职位数",
    id: 1,
    value: "updated_desc",
    arr: "down"
  },
  {
    name: "创建时间",
    id: 2,
    value: "probation_asc",
    arr: "down"
  }
];

export default {
  name: "clientmanage",
  extends: baseComponentVue,
  components: {
    Pagination,
    EditClient,
    EditMessage,
    ClientMessage,
    ReviewUnPass,
    ReviewPass,
    EditLook,
    ShowLook,
    TransformStaffModal
    
  },
  data() {
    this.handleSearchBD = debounce(this.handleSearchBD, 800);
    return {
      loading: false,
      form: this.$form.createForm(this),
      options: [],
      category_id: [],
      topMenuKey: +this.$route.query.tab || menus[0].key,
      menus,
      sorts,
      listData: [],
      pagination: undefined,
      total: "0",
      record: {},
      companyId: undefined,
      companyInfo: undefined,
      databd: [],
      main: "name",
      mainValue: "",
      resumeHR: true,
      resumeHRBD: false,
      resumeHRD: false,
      // status:undefined,
      stype: "",
      created_start: "",
      created_end: "",
      bd_ie_uid: "",
      jobTitle: "",
      // is_sign: "",
      audit_status: "",
      province_id: "",
      city_id: "",
      dist_id: "",
      companyname: "",
      fullname: "",
      shortname: "",
      visible: false,
      createdName: ""
    };
  },
  created() {
    this.createdName = this.$store.getters.getUsers.name;
  },
  computed: {
    ...mapState(["addCompany", "user"])
  },
  watch: {
    addCompany(val) {
      if (val) {
        this.showAddCompany();
      }
    }
  },
  mounted() {
    // console.log(this.user, 'useruseruser')
    if (this.$route.query.id) {
      this.databd = [
        { uid: this.$route.query.id, name: this.$route.query.name }
      ];
      this.form.setFieldsValue({
        bdname: this.$route.query.id
      });
    }
    this.pagination = this.$refs.pagination;
    if (this.$route.query.tab) {
      this.handleTabChange(this.$route.query.tab);
    } else {
      this.getListData();
    }
    if (this.addCompany) {
      this.showAddCompany();
    }
  },
  methods: {
    handleTabChange(val) {
      if (val == 0) {
        // this.is_sign = "";
        delete this.is_sign;
        this.audit_status = "";
      } else if (val == 1) {
        this.is_sign = 1;
        this.audit_status = "";
      } else if (val == 2) {
        this.is_sign = 0;
        this.audit_status = "";
      } else if (val == 3) {
        this.is_sign = "";
        this.audit_status = "CREATED";
      } else if (val == 4) {
        this.is_sign = "";
        this.audit_status = "REJECTED";
      } else if (val == 5) {
        this.is_sign = "";
        this.audit_status = "ACCEPTED";
      }
      this.getListData();
    },
    showAddCompany() {
      this.$refs.editModal.type = "add";
      this.$refs.editModal.show();
      this.$store.commit("addCompany", false);
    },
    handleChange(value) {
      if (value == "0") {
        this.resumeHR = true;
        this.resumeHRBD = false;
        this.resumeHRD = false;
      } else if (value == "1") {
        this.resumeHR = false;
        this.resumeHRBD = true;
        this.resumeHRD = false;
      } else if (value == "2") {
        this.resumeHR = false;
        this.resumeHRBD = false;
        this.resumeHRD = true;
      }
    },
    handleSearchBD(value) {
      if (!value) return;
      Api.hrlist.searchBD({ name: value }).then(response => {
        console.log(response);
        this.databd = response;
      });
    },
    getpage(value) {
      console.log(value);
    },
    async getListData(pagination) {
      this.loading = true;
      let moment = require("moment");
      this.form.validateFields((err, values) => {
        if (!err) {
          this.created_start = values.dateModel
            ? `${moment(values.dateModel[0]).format("YYYY-MM-DD")} 00:00:00`
            : "";
          this.created_end = values.dateModel
            ? `${moment(values.dateModel[1]).format("YYYY-MM-DD")} 00:00:00`
            : "";
          this.bd_ie_uid = values.bdname;
        }
      });
      let params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        created_start: this.created_start,
        created_end: this.created_end,
        bd_ie_uid: this.bd_ie_uid,
        audit_status: this.audit_status,
        contract_type: this.stype,
        is_sign: this.is_sign,
        [this.main]: this.mainValue,
        city_id: this.city_id,
        dist_id: this.dist_id
      };
      if (pagination) {
        params.page = pagination.current;
        params.limit = pagination.pageSize;
      }
      let response = await Api.client.getList(params);
      if (response) {
        this.loading = false;
        this.listData = response.list;
        this.total = response.total;
      }
    },
    onChangecity(value) {
      this.province_id = value[0];
      this.city_id = value[1];
      this.dist_id = value[2];
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
    },
    selectList() {
      this.pagination.current = 1;
      this.getListData();
    },
    clearSelect() {
      this.form.resetFields();
      this.main = "name";
      this.mainValue = "";
      this.province_id = "";
      this.city_id = "";
      this.dist_id = "";
      this.created_start = "";
      this.created_end = "";
      this.bd_ie_uid = "";
      this.stype = "";
      this.companyname = "";
      this.shortname = "";
      this.fullname = "";
      this.jobTitle = "";
      this.audit_status = "";
      this.is_sign = "";
      delete this.is_sign;
      this.getListData();
    },
    changeSort(sort) {
      console.log(sort);
    },
    operateStaff(item) {
      let { editModal } = this.$refs;
      this.visible = true;
      editModal.type = "add";
      if (item) {
        editModal.type = "edit";
        console.log(item);
        editModal.show(item);
      } else {
        editModal.show();
      }
    },
    addHr(item) {
      console.log(item);
      let { editHrModal } = this.$refs;
      editHrModal.show(item);
    },
    async showClientMsg(item) {
      this.loading = true;
      let { ClinetMsgModal } = this.$refs;
      ClinetMsgModal.type = "add";
      if (item) {
        this.companyId = parseInt(item);
        let response = await Api.client.getDetail({
          company_id: this.companyId
        });
        if (response) {
          this.loading = false;
          this.companyInfo = response.company;
        }
        ClinetMsgModal.type = "edit";
      }
      ClinetMsgModal.show();
    },
    goContract(item) {
      console.log(item);
      this.companyId = Number(item.id);
      this.$router.push({
        path: "client-manage/contract",
        query: {
          id: item.id,
          name: item.name
        }
      });
    },
    reviewUnPass(item) {
      console.log(item);
      this.$refs.reviewUnPassModel.show(item);
    },
    reviewPass(item) {
      console.log(11111);
      this.$refs.reviewPassModel.show(item);
    },
    editLook(item) {
      this.$refs.editLook.show(item);
    },
    showLook(item) {
      this.$refs.showLook.show(item);
    }
  }
};
</script>

<style lang="scss">
#order {
  .ant-form-item-control {
    line-height: 0;
  }
  .order-sub-menu.ant-menu {
    .ant-menu-item {
      line-height: 56px;
      height: 56px;
      text-align: center;
      &.ant-menu-item-selected {
        font-weight: bold;
      }
    }
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .order-sub-menu {
    margin-bottom: 20px;
  }
  .select {
    width: 100%;
  }
  .noborder {
    border: 0;
  }
  .order-page-type {
    .clear-screen {
      height: 40px;
      border-radius: 4px;
      color: #5ec9ff;
      border: 1px solid #5ec9ff;
      margin-right: 10px;
      font-weight: bold;
    }
    .screen {
      color: #ffffff;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
      font-weight: bold;
    }
    .left {
      position: absolute;
      right: 20px;
    }
  }
  .sort-bar {
    text-align: center;
    margin-top: 20px;
    border-radius: 3px;
    background: #35b5fe;
    border: 1px solid rgba(228, 232, 235, 1);
    .sort {
      cursor: pointer;
      font-size: 16px;
      height: 58px;
      line-height: 58px;
      color: #ffffff;
      &.active {
        color: #35b5fe;
      }
    }
  }
  .data-list {
    padding-left: 0;
    li {
      list-style: none;
      cursor: pointer;
      margin-top: 11px;
      border-radius: 3px;
      border: 1px solid rgba(228, 232, 235, 1);
      position: relative;
      padding: 18px 32px 20px 40px;
      &:hover {
        background: #f5f7fa;
      }
      img.shang {
        position: absolute;
        left: 0;
        top: 0;
        width: 35px;
      }
      .row {
        &.row2 {
          padding-top: 10px;
        }
        .col {
          display: flex;
          align-items: center;
          &.gap {
            span:not(:last-child) {
              margin-right: 16px;
            }
          }
          span {
            display: inline-block;
            &.title {
              font-size: 16px;
              font-weight: bold;
            }
            &.ji {
              font-size: 12px;
              background: #ff6b5d;
              border-radius: 2px;
              height: 18px;
              color: #fff;
              padding: 0 3px;
            }
            &.hc {
              background: #f6b502;
              padding: 0 3px;
              font-size: 12px;
              border-radius: 2px;
              height: 18px;
              color: #fff;
            }
            &.time {
              color: #999;
            }
            &.salary {
              font-size: 16px;
              color: #fc5646;
            }
            .anticon {
              font-size: 18px;
              margin-right: 5px;
            }
          }
          a {
            display: inline-block;
            margin-left: 20px;
            img {
              margin-right: 5px;
            }
          }
          .ant-btn {
            margin-left: 20px;
          }
        }
      }
    }
  }
  .list {
    min-height: 120px;
  }
  .content {
    width: 50%;
    height: 100%;
  }
  .contentLeft {
    width: 32%;
    text-align: right;
  }
  .contentRight {
    width: 15%;
    text-align: center;
  }
  .company {
    font-size: 16px;
    font-weight: 400;
    margin-right: 10px;
  }
  .sign {
    font-size: 16px;
    font-weight: 400;
    margin-right: 10px;
    color: green;
  }
  .unsign {
    font-size: 16px;
    font-weight: 400;
    margin-right: 10px;
    color: red;
  }
  .status {
    display: inline-block;
    border-radius: 15px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background: green;
    color: #ffffff;
  }
  .unstatus {
    display: inline-block;
    border-radius: 15px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background: red;
    color: #ffffff;
  }
  .companyStatus {
    margin: 5px 0;
    color: #999999;
  }
  .createtime {
    margin: 4px 0;
    color: #999999;
  }
  .blue {
    color: #35b5fe;
  }
  .gap {
    margin-left: 40px;
  }
  .edit {
    margin-bottom: 3px;
    text-decoration: underline;
    .editimg {
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }
  }
}
</style>
